// import VT from '@/store/types';

export default {
  // [VT.AI_MODELS_LIST]: (state, { data, status }) => {
  //   state.aiModelsList = { data, status };
  // },
};
